var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/scripts/loading-button.js ***!
  \***************************************/
class loadingButton extends HTMLElement {
  constructor() {
    super()
    this.url = '';
    this.loadButton =  this.querySelector('button');
    this.productContainer =  document.querySelector('#main-grid');
    this.vanillaPagination =  document.querySelector('#pagination');
    this.visualWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    this.loadButton.addEventListener(
      'click',
      this.loadMore.bind(this)
    );
  }

  loadMore(event) {
    this.url = document.querySelector('.pagination-wrapper a.next-item').href;
    this.loadButton.classList.add('loading');
    this.fetchItems(this.url, event);
  }

  fetchItems(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProductGrid(html);
        this.renderNewNavigation(html);
        this.loadingButtonChecker(event);
      });
  }

  renderProductGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('main-grid').innerHTML
    if (document.querySelector("masonry-grid")) {
      this.masonryGrid(newPage)
    } else {
      this.productContainer.innerHTML = this.productContainer.innerHTML + newPage
    }
  }
  renderNewNavigation(html) {
    this.vanillaPagination.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('pagination').innerHTML;
  }

  masonryGrid(newPage) {
    if (this.visualWidth > 780) {
      document.getElementById('main-grid').removeAttribute('style');
      document.querySelectorAll('.grid__item').forEach((item) => {
        item.removeAttribute('style')
      })
      window.msnry.destroy()
      setTimeout(() => {
        let grid = document.querySelector('.masonry')
        let msnry = new Masonry( grid, {
          itemSelector: '.masonry-item',
          columnWidth: '.grid-sizer',
          percentPosition: true
        });
        window.msnry = msnry;
      }, 10)
    }

    let newPageClean = newPage.replace('<div class="grid-sizer"></div>', '');
    this.productContainer.innerHTML = this.productContainer.innerHTML + newPageClean

  }

  loadingButtonChecker(event) {
    this.loadButton.classList.remove('loading');
    if (document.querySelectorAll('.pagination-wrapper a.next-item').length === 0) {
      this.loadButton.classList.add('hidden')
    }
  }

}
customElements.define('loading-button', loadingButton)

